import { useEffect, useMemo, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import SettingsService from "../Services/SettingsService";
import SettingsModel from "../Models/SettingsModel";

const Settings = () => {
  const { instance } = useMsal();

  const settingsService = useMemo(
    () => new SettingsService(instance),
    [instance]
  );

  const [settings, setSettings] = useState<SettingsModel>();

  useEffect(() => {
    async function loadData() {
      try {
        const data = await settingsService.get();

        setSettings(data);
      } catch (err) {
        toast.error("Fout bij het ophalen van de data.");
      }
    }

    loadData();
  }, [settingsService]);

  const save = async () => {
    try {
      if (settings) {
        await settingsService.update(settings);
      }
    } catch (error) {
      toast.error("Fout bij het ophalen van de data.");
    }
  };

  return (
    <div className="container-fluid">
      <table className="table table-sm text-nowrap">
        <tbody>
          <tr>
            <td>Melding bij nieuw verlof</td>
            <td>
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="columnValueInput"
                    onChange={(event) =>
                      setSettings({
                        newLeaveRequestMessage: event.target.value,
                      })
                    }
                    value={settings?.newLeaveRequestMessage}
                  />
                </div>
              </form>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="row m-4">&nbsp;</div>
      <div
        className="container-fluid fixed-bottom pb-2 pt-2"
        style={{ backgroundColor: "white" }}
      >
        <button className="btn btn-primary" type="button" onClick={save}>
          Bewaren
        </button>
      </div>
    </div>
  );
};

export default Settings;
